// @codekit-prepend "_libraries/_ie-html5-fix.js"
// @codekit-prepend "_libraries/_modernizr.js"
// @codekit-prepend "_libraries/_jquery.debouncing.js"

// @codekit-prepend "_libraries/_jquery.scroll-toggle.js"

// @codekit-prepend "_libraries/_jquery.make-sticky.js"
// @codekit-prepend "_libraries/_jquery.scroll-to-anchor.js"
// @codekit-prepend "_libraries/_jquery.set-height-to-viewport.js"
// @codekit-prepend "_libraries/_jquery.toggle-class.js"

// @codekit-prepend "_libraries/_jquery.instagram-feed.js"
// @codekit-prepend "_libraries/_jquery.flickr-feed.js"

// @codekit-prepend "_libraries/_jquery.srzsd-slider.js"
// @codekit-prepend "_libraries/_jquery.srzsd-drawer.js"

// @codekit-prepend "_libraries/_srzsd.css-loader.js"
// @codekit-prepend "_libraries/_srzsd.show-mailto.js"

srzsd.ladeCSS("/css/js.css");

$(function(){

	$("body").removeClass("js-hidden");

	$(".srzsd-slider").srzsdSlider();
	$(".srzsd-drawer").srzsdDrawer();

	$(".instagram-feed").instagramFeed();
	$(".flickr-feed").flickrFeed();

//	$("#contact, #content").setHeightToViewport();
//	$(".main-content > section").setHeightToViewport();
	$("#contact").setHeightToViewport();

	$(document).scrollToAnchor();

	var initToggleClass = function (){

		setTimeout(function(){

			$(".set-sticky").makeSticky();
			$(".toggle-class").toggleClass({
				target: $(".main-nav")
			});

		}, 200);

	};

	setTimeout(function(){
		initToggleClass();
	}, 1500);

});
